import React, { useState } from "react";
import { Form, Input, Button, message, Card } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { adminChangePassword } from "../../api";
import { useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const adminUsername = localStorage.getItem("admin_username") || "";

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const res = await adminChangePassword({
        username: adminUsername,
        password: values.newPassword,
      });

      if (res.success) {
        message.success("密码修改成功！请重新登录");
        localStorage.removeItem("admin_token");
        localStorage.removeItem("admin_username");
        navigate("/login", { replace: true });
      } else {
        message.error(res.error || "密码修改失败");
      }
    } catch (err) {
      message.error("网络异常，请重试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="修改管理员密码" style={{ maxWidth: 600, margin: "20px auto", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
        initialValues={{ username: adminUsername }}
        autoComplete="off" // 优化体验：关闭自动填充
      >
        <Form.Item
          name="username"
          label="当前账号"
          rules={[{ required: true, message: "账号不能为空" }]}
        >
          <Input 
            disabled 
            placeholder="当前登录账号" 
            prefix={<UserOutlined className="form-item-prefix" />} 
            style={{ borderRadius: 4 }}
          />
        </Form.Item>

        <Form.Item
          name="newPassword"
          label="新密码"
          rules={[
            { required: true, message: "请输入新密码" },
            { min: 6, message: "密码长度不能少于6位" },
          ]}
          hasFeedback
        >
          <Input.Password 
            placeholder="请输入新密码" 
            prefix={<LockOutlined className="form-item-prefix" />} 
            size="middle"
            style={{ borderRadius: 4 }}
          />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="确认新密码"
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "请确认新密码" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("两次输入的密码不一致！"));
              },
            }),
          ]}
          hasFeedback
        >
          <Input.Password 
            placeholder="请确认新密码" 
            prefix={<LockOutlined className="form-item-prefix" />} 
            size="middle"
            style={{ borderRadius: 4 }}
          />
        </Form.Item>

        <Form.Item>
          <Button 
            type="primary" 
            htmlType="submit" 
            loading={loading} 
            style={{ marginRight: 16, borderRadius: 4 }}
          >
            确认修改
          </Button>
          <Button 
            type="default" 
            onClick={() => form.resetFields()}
            style={{ borderRadius: 4 }}
          >
            重置
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default ChangePassword;